module.exports = __webpack_public_path__ + "img/chart_grey.f3f5575b.svg";